import React, { Component } from 'react';
import { connect } from 'react-redux';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import DotIcon from '@material-ui/icons/Lens';

import { receiveError } from '../../../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../../../api/pickupOrderRemote';

import SecurityDetails from './SecurityDetails';
import TruckDetails from './TruckDetails';
import CommonTruckerLockedContainer from '../../../../common/trucker/truckerLocked/CommonTruckerLockedContainer';

import ApiResponse from '../../../../../models/ApiResponse';
import ResponseError from '../../../../../models/ResponseError';
import PickupOrderGha from '../../../../../models/PickupOrderGha';

import securityDetailsStyles from './securityDetails.module.css';
import commonStyles from '../../../../common/common.module.css';

import { PO_SCHEMA_GHA } from '../../../../../utils/pickupOrder';
import CarrierDetails from './CarrierDetails';

const styles = (theme: Theme) =>
  createStyles({
    red: {
      color: 'red',
      fontSize: 18,
      marginLeft: 8,
      marginTop: 12,
    },
    green: {
      color: 'green',
      fontSize: 18,
      marginLeft: 8,
      marginTop: 12,
    },
    input: {
      padding: '11px 14px',
      color: 'var(--primaryblue)'
    },
    blue: {
      transform: 'translate(14px, 12px) scale(1)',
      color: 'var(--primaryblue)',
      fontSize: '13px ',
    },
    textField: {
      marginRight: '20px',
     },
    '@media (max-width: 480px)':{
    textField: {
      marginRight: '0px',
     },
  }
   
  });
  
interface SecurityDetailsContainerProps {
  classes: any;
  dropOffOrder: PickupOrderGha;
  selectedDooNumber: string;
  receiveError: (error: ResponseError) => void;
};

interface TruckInfoType {
  rfsNumber: string;
  truckPlateNumber: string;
};

interface SecurityDetailsContainerState {
  iac_number: string;
  truckInfo: TruckInfoType;
  sealedUpdated: boolean;
  lockedOrSealed: string;
  valid_transportation: boolean;
  doo: PickupOrderGha;
  validSealNumber: boolean;
  showIacDot: boolean;
  carrierNumber: any;
  carrierList: Array<string>;
};

class SecurityDetailsContainer extends Component<SecurityDetailsContainerProps, SecurityDetailsContainerState> {
  state: SecurityDetailsContainerState = {
    iac_number: '',
    sealedUpdated: false,
    lockedOrSealed: '',
    truckInfo: {
      rfsNumber: '',
      truckPlateNumber: '',
    },
    valid_transportation: false,
    doo: PO_SCHEMA_GHA,
    showIacDot: false,
    validSealNumber: true,
    carrierNumber: {},
    carrierList: []
  };

  componentDidMount() {
    const doo: PickupOrderGha = { ...this.props.dropOffOrder };
    let iac_number: string = '';
    let rfsNumber: string = '';
    let truckPlateNumber: string = '';
    let showIacDot: boolean = false;

    if (doo.iac_number) {
      iac_number = doo.iac_number;
    }

    if (doo.rfs_number) {
      rfsNumber = doo.rfs_number;
    }

    if (doo.driver_vehichle_registration) {
      truckPlateNumber = doo.driver_vehichle_registration;
    }

    if (iac_number) {
      showIacDot = true;
    }
    let carrierNumber = { ...this.state.carrierNumber }
    if(doo.interline_transfer_program) {
      carrierNumber = { label: doo.interline_transfer_program.carrier,  value: doo.interline_transfer_program.carrier }
    }
    const truckInfo: TruckInfoType = {
      rfsNumber: rfsNumber,
      truckPlateNumber: truckPlateNumber,
    };
    this.getCarrierList();
    this.setState({ doo, iac_number, truckInfo, showIacDot, validSealNumber: doo.valid_seal_number, valid_transportation: doo.valid_transportation, carrierNumber });
  }

  componentDidUpdate(prevProps: SecurityDetailsContainerProps) {
    if (prevProps.dropOffOrder !== this.props.dropOffOrder) {
      let iac_number: string = '';
      let showIacDot: boolean = false;
      let rfsNumber: string = '';
      let truckPlateNumber: string = '';

      if (this.props.dropOffOrder.iac_number) {
        iac_number = this.props.dropOffOrder.iac_number;
      }

      if (this.props.dropOffOrder.iac_number) {
        iac_number = this.props.dropOffOrder.iac_number;
      }
      if (this.props.dropOffOrder.rfs_number) {
        rfsNumber = this.props.dropOffOrder.rfs_number;
      }

      if (this.props.dropOffOrder.driver_vehichle_registration) {
        truckPlateNumber = this.props.dropOffOrder.driver_vehichle_registration;
      }

      if (iac_number) {
        showIacDot = true;
      }

      const truckInfo: TruckInfoType = {
        rfsNumber: rfsNumber,
        truckPlateNumber: truckPlateNumber,
      };

      this.setState({
        doo: this.props.dropOffOrder,
        truckInfo,
        showIacDot,
        iac_number,
        validSealNumber: this.props.dropOffOrder.valid_seal_number,
        valid_transportation: this.props.dropOffOrder.valid_transportation,
      });
    }
  }

  handleSealedUpdate = (data: any): void => {
    this.setState({ lockedOrSealed: 'sealed' });

    const doo: PickupOrderGha = data;

    const bodyObject: { locked: boolean; sealed: boolean; seal_number: string } = {
      locked: doo.locked,
      sealed: doo.sealed,
      seal_number: doo.seal_number,
    };

    this.handleSendSecurityDetails(doo, bodyObject, true, true);
  };

  handleLockedSealedChange = (data: any): void => {
    const doo: PickupOrderGha = { ...data };

    this.setState({ lockedOrSealed: doo.locked ? 'locked' : 'sealed' });

    if (doo.locked) {
      const bodyObject: { locked: boolean; sealed: boolean; seal_number: string } = {
        locked: doo.locked,
        sealed: doo.sealed,
        seal_number: doo.seal_number,
      };

      this.handleSendSecurityDetails(doo, bodyObject, true, false);
    }

    this.setState({ doo });
  };

  getCarrierList = (): void => {
    pickupOrderRemote.getCarrierList().then((resp: ApiResponse<any>)=> {
      const list: any | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (list) {

        this.setState({ carrierList: list })
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  handleIacChange = (event: any, type: string): void => {
    if(type === 'select') {
      this.setState({ carrierNumber: event }, () => {
        this.setCarrierData();
      });
    } else {
      let value = event.target.value;
      if (value === '') this.setState({ showIacDot: false });
      this.setState({ iac_number: value });
    }
    
  };

  handleChange = (propertyName: string, event: any): void => {
    const value: string = event.target.value;
    const truckInfo: TruckInfoType = { ...this.state.truckInfo };

    switch (propertyName) {
      case 'truckPlateNumber':
        truckInfo.truckPlateNumber = value;
        break;
      case 'rfsNumber':
        truckInfo.rfsNumber = value;
        break;
      default:
        break;
    }

    this.setState({ truckInfo });
  };

  setCarrierData = (): void => {
    pickupOrderRemote.updateGhaPoInterlineChecks(this.props.dropOffOrder.number, this.state.carrierNumber).then((resp: ApiResponse<any>) => {
      const error: ResponseError | undefined = resp.error;

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  loseFocus = (propertyName: string): void => {
    const bodyObject: any = {};

    switch (propertyName) {
      case 'truckPlateNumber':
        bodyObject['driver_vehichle_registration'] = this.state.truckInfo.truckPlateNumber;
        break;
      case 'rfsNumber':
        bodyObject['rfs_number'] = this.state.truckInfo.rfsNumber;
        break;
      default:
        break;
    }

    this.doSaveGhaExportTruckInfo(this.props.selectedDooNumber, bodyObject);
  };

  doSaveGhaExportTruckInfo = (dooNumber: string, bodyObject: any): void => {
    pickupOrderRemote.saveGhaExportDriverInfo(dooNumber, bodyObject).then((resp: ApiResponse<PickupOrderGha>) => {
      const error: ResponseError | undefined = resp.error;

      if (error) {
        this.props.receiveError(error);
      }
    });
  };

  doUpdateAndCheckIACNumber = () => {
    const doo: PickupOrderGha = { ...this.state.doo };

    if (doo.number !== '') {
      const bodyObject: { iac_number: string } = { iac_number: this.state.iac_number };
      this.handleSendSecurityDetails(doo, bodyObject, false, false);
    }
  };

  handleSendSecurityDetails = (doo: PickupOrderGha, bodyData: any, ignoreSetValidTransportation: boolean, sealedRequest: boolean): void => {
    const bodyObject: any = {
      sealed: bodyData.sealed !== undefined ? doo.sealed : undefined,
      seal_number: bodyData.seal_number !== undefined ? bodyData.seal_number : undefined,
      locked: bodyData.locked !== undefined ? doo.locked : undefined,
      iac_number: bodyData.iac_number !== undefined ? this.state.iac_number : undefined,
    };

    pickupOrderRemote
      .setSecurityDetails(doo.number, bodyObject)
      .then(
        (
          resp: ApiResponse<{
            locked: boolean;
            sealed: boolean;
            seal_number: string;
            iac_number?: string;
            valid_transportation?: boolean;
            valid_seal_number?: boolean;
          }>,
        ) => {
          const securityDetails:
            | { locked: boolean; sealed: boolean; seal_number: string; iac_number?: string; valid_transportation?: boolean; valid_seal_number?: boolean }
            | undefined = resp.result;
          const error: ResponseError | undefined = resp.error;

          if (securityDetails) {
            if (securityDetails.valid_seal_number !== undefined) this.setState({ validSealNumber: securityDetails.valid_seal_number });

            doo.sealed = securityDetails.sealed;
            doo.seal_number = securityDetails.seal_number;
            doo.locked = securityDetails.locked;
            doo.iac_number = securityDetails.iac_number ? securityDetails.iac_number : '';

            if (bodyObject.iac_number !== undefined) {
              this.setState({ showIacDot: bodyObject.iac_number.length > 0 });
            }

            if (ignoreSetValidTransportation) {
              this.setState({ doo, sealedUpdated: sealedRequest });
            } else {
              this.setState({
                doo,
                sealedUpdated: sealedRequest,
                valid_transportation: securityDetails.valid_transportation ? securityDetails.valid_transportation : false,
              });
            }
          }

          if (error) {
            this.props.receiveError(error);
          }
        },
      );
  };

  render() {
    const { classes } = this.props;
    const colorStyle: string = this.state.validSealNumber ? classes.green : classes.red;
    const rfsDisabled: boolean = this.state.doo.rfs_number ? false : true;

    return (
      <div className={ `${ commonStyles.wrapper } ${ securityDetailsStyles.wrapper }` }>
        <h3 className={ commonStyles.header }>Truck and Security Details</h3>
        <div className={ securityDetailsStyles.wrapperFields }>
          <div className={ securityDetailsStyles.driverInfoWrapperFirstRow }>
            <TruckDetails 
              loseFocus={ this.loseFocus } 
              disabled={ rfsDisabled } 
              handleChange={ this.handleChange } 
              truckInfo={ this.state.truckInfo } 
            />
            <div className={ securityDetailsStyles.lockedWrapper }>
              <CommonTruckerLockedContainer
                dropOffOrder={ this.props.dropOffOrder }
                inputFocusChanged={ this.handleSealedUpdate }
                setContainerState={ this.handleLockedSealedChange }
                view={ 'ghaExport' }
                editable={ true }
              />
              { this.state.doo.sealed && <DotIcon className={colorStyle} /> }
            </div>
            { this.props.dropOffOrder.forwarder_company_info.type !== 'interline' && this.props.dropOffOrder.iac_number && <SecurityDetails
              iacNumber={ this.state.iac_number }
              iacNumberValid={ this.state.valid_transportation }
              loseFocus={ this.doUpdateAndCheckIACNumber }
              disabled={ this.props.dropOffOrder.allowed_ops.update_dispatch_driver_details }
              handleChange={ this.handleIacChange }
              showIacDot={ this.state.showIacDot }
            /> }
            { this.props.dropOffOrder.forwarder_company_info.type === 'interline' && !this.props.dropOffOrder.iac_number && <CarrierDetails
              carrier={ this.state.carrierNumber }
              disabled={ this.props.dropOffOrder.allowed_ops.update_dispatch_driver_details }
              handleChange={ this.handleIacChange }
              carrierList={ this.state.carrierList }
            /> }
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
  };
};

export default withStyles(styles)(connect(null, mapDispatchToProps)(SecurityDetailsContainer));
